import {
  Directive,
  Input,
  ElementRef,
  Renderer2,
  HostListener,
} from '@angular/core';

@Directive({
  selector: '[appTooltip]'
})
export class TooltipDirective {
  @Input() tooltipMessage: string = '';
  tooltip: HTMLElement | null = null;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('mouseenter') onMouseEnter() {
    if (!this.tooltipMessage) return;
    this.tooltip = this.renderer.createElement('div');
    this.renderer.appendChild(
      this.tooltip,
      this.renderer.createText(this.tooltipMessage)
    );

    this.renderer.appendChild(document.body, this.tooltip);
    this.renderer.addClass(this.tooltip, 'tooltip-popover');
    const { top, left, width } = this.el.nativeElement.getBoundingClientRect();
    const tooltipHeight = this.tooltip.offsetHeight;

    this.renderer.setStyle(this.tooltip, 'position', 'absolute');
    this.renderer.setStyle(this.tooltip, 'top', `${top - tooltipHeight - 5}px`);
    this.renderer.setStyle(this.tooltip, 'left', `${left + width / 2}px`);
    this.renderer.setStyle(this.tooltip, 'transform', 'translateX(-50%)');
  }

  @HostListener('mouseleave') onMouseLeave() {
    if (this.tooltip) {
      this.renderer.removeChild(document.body, this.tooltip);
      this.tooltip = null;
    }
  }
}
